import { Component } from "react";

export interface Props {
    text: Record<string, string>;
    lang: string;
};

export default class Subtitle extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }
    render() {
        return (
            <div className="subheading mb-3">{this.props.text[this.props.lang]}</div>
        );
    }
}
